let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ddr6L")).then(() => parcelRequire('fQYLG'));